import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { SuiSearchInput } from '@splashthat/sui';
import { containerPaddingXs, containerPaddingM } from 'common/styles/variables';

const SEARCH_PLACEHOLDER = 'Search My Questions';

const SearchInputContainer = styled.div`
    margin-bottom: ${containerPaddingM};
    margin-top: ${containerPaddingXs};
`;

const FormTemplateSearchInput = ({ onSearch, value }) => (
    <SearchInputContainer>
        <SuiSearchInput
            fullWidth
            defaultValue=""
            value={value}
            placeholder={SEARCH_PLACEHOLDER}
            debounceTime={0}
            onSearch={onSearch}
        />
    </SearchInputContainer>
);

FormTemplateSearchInput.propTypes = {
    onSearch: PropTypes.func.isRequired,
    value: PropTypes.string,
};

FormTemplateSearchInput.defaultProps = {
    value: '',
};

export default FormTemplateSearchInput;
